export default function(data = {}) {
    this.organizations = data.organizations || []
    this.periods = data.periods || []
}
